import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#050b14] border-t border-white/10 pt-16 pb-8" data-id="element-288">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-289">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-290">
          {/* Brand Column */}
          <div data-id="element-291">
            <div className="flex items-center gap-2 mb-6" data-id="element-292">
              <div className="bg-[#d4a853] text-[#0a1628] font-bold text-2xl px-3 py-1.5 rounded" data-id="element-293">
                888
              </div>
              <div className="text-white font-bold text-sm uppercase tracking-wider" data-id="element-294">
                Sourcing
                <br data-id="element-295" />
                Limited
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-296">
              Professional product sourcing and market development company
              connecting manufacturers with leading hypermarkets, supermarket
              chains, and retail distributors across the UK, Europe, and Asia.
            </p>
          </div>

          {/* Services */}
          <div data-id="element-297">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-298">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-299">
              <li data-id="element-300">Product Sourcing</li>
              <li data-id="element-301">Manufacturer Representation</li>
              <li data-id="element-302">Market Entry</li>
              <li data-id="element-303">Procurement Management</li>
              <li data-id="element-304">Product Promotion</li>
            </ul>
          </div>

          {/* Regions */}
          <div data-id="element-305">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-306">
              Regions
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-307">
              <li data-id="element-308">United Kingdom</li>
              <li data-id="element-309">France & EU</li>
              <li data-id="element-310">Germany</li>
              <li data-id="element-311">Asia & Middle East</li>
              <li data-id="element-312">Global</li>
            </ul>
          </div>

          {/* Legal/Contact */}
          <div data-id="element-313">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-314">
              Legal
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-315">
              <li data-id="element-316">
                <Link to="/privacy-policy" className="hover:text-[#d4a853] transition-colors" data-id="element-317">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-318">
                <Link to="/terms-of-service" className="hover:text-[#d4a853] transition-colors" data-id="element-319">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-320">
                <Link to="/cookie-policy" className="hover:text-[#d4a853] transition-colors" data-id="element-321">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-322">
                <Link to="/sitemap" className="hover:text-[#d4a853] transition-colors" data-id="element-323">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-324">
          <p className="text-gray-500 text-xs" data-id="element-325">
            © {new Date().getFullYear()} 888 Sourcing Limited. All rights
            reserved.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-326">
            Connecting manufacturers with global retail markets.
          </p>
        </div>
      </div>
    </footer>;
}